module.exports = __webpack_public_path__ + "assets/img/15.5f029e88.png";